module.exports = __webpack_public_path__ + "img/btn_menu_tljdh.f49f606a.png";